<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec hidden-over" id="main">
    <div class="container">
      <div class="side-heading">
        <h6>{{ $t('dashboardHome.dashboard') }}</h6>
        <p class="font14 gray-col">مرحبا بك استاذ {{ userName }} اهلا بعودتك</p>
      </div>
      <div v-if="!loader">
        <HomeBoxes
          :recent_buildings="recent_buildings"
          :management_orders="management_orders"
          :all_buildings="all_buildings"
          :maintenance_orders="maintenance_orders"
        />
      </div>

      <div class="row" v-else>
        <div class="col-lg-3 col-md-4 col-12">
          <Skeleton width="100%" height="170px" class="mb-2"></Skeleton>
        </div>
        <div class="col-lg-3 col-md-4 col-12">
          <Skeleton width="100%" height="170px" class="mb-2"></Skeleton>
        </div>
        <div class="col-lg-3 col-md-4 col-12">
          <Skeleton width="100%" height="170px" class="mb-2"></Skeleton>
        </div>
        <div class="col-lg-3 col-md-4 col-12">
          <Skeleton width="100%" height="170px" class="mb-2"></Skeleton>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-lg-6 col-12 mb-3"><chartView :total_profits="total_profits" /></div>
        <div class="col-lg-6 col-12 mb-3">
          <clientsReviews  :rates="rates" :loader="loader"/>
      
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";
import HomeBoxes from "../components/dashboard/HomeBoxes.vue";
import clientsReviews from "../components/dashboard/clientsReviews.vue";
import chartView from "../components/dashboard/chartView.vue";
import Skeleton from "primevue/skeleton";

import { onMounted, ref } from "vue";
import axios from "axios";

// reactive states
const loader = ref(false);
const recent_buildings = ref("");
const management_orders = ref("");
const all_buildings = ref("");
const maintenance_orders = ref("");
const total_profits = ref("");
const rates = ref([]);

const userName = ref("");
// functions
function getHomeDashboard() {
  loader.value = true;
  axios
    .get("/manager/dashboard-home", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      recent_buildings.value = response.data.data.recent_buildings;
      management_orders.value = response.data.data.management_orders;
      all_buildings.value = response.data.data.all_buildings;
      maintenance_orders.value = response.data.data.maintenance_orders;
      total_profits.value = response.data.data.total_profits;
      rates.value = response.data.data.rates;
      loader.value = false;
    });
}

// lifecycle hooks
onMounted(() => {
  getHomeDashboard();
  userName.value = localStorage.getItem("userName");
});
</script>
